// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"284":"f980eb65","939":"b308958e"}[chunkId] + ".css";
};